<template>
  <div>
    <div v-if="allSubmissions.length">
      <v-row
        justify="center"
        v-for="form in allSubmissions"
        :key="form.form_submission_id"
        class="mx-4"
      >
        <v-col cols="12" md="12">
          <v-hover v-slot:default="{ hover }">
            <v-card
              class="mx-auto pointed-cursor"
              outlined
              ripple
              :elevation="hover ? 2 : 0"
              @click="openForm(form)"
            >
              <v-row>
                <v-col
                  v-for="data in form.data"
                  :key="data.option_key"
                  style="width: 15% !important"
                  class="pr-0"
                >
                  <v-card-title class="pr-0 text-break">{{
                    data.name
                  }}</v-card-title>
                  <v-card-text class="pr-0 text-break">
                    {{ data.data || 'N/A' }}
                  </v-card-text>
                </v-col>
                <v-col
                  cols="1"
                  style="width: 4% !important"
                  class="pt-12 pl-1"
                  v-if="deletePermission || form.pdf_url"
                >
                  <v-tooltip top v-if="form.pdf_url">
                    <template #activator="{ on }">
                      <v-btn
                        color="black"
                        dark
                        class="mr-1"
                        fab
                        x-small
                        depressed
                        v-on="on"
                        @click.stop.prevent="generatePdf(form.pdf_url)"
                      >
                        <v-icon>picture_as_pdf</v-icon>
                      </v-btn>
                    </template>
                    <span>PDF</span>
                  </v-tooltip>
                  <v-tooltip top v-if="deletePermission">
                    <template #activator="{ on }">
                      <v-btn
                        color="error"
                        fab
                        x-small
                        depressed
                        v-on="on"
                        @click.stop.prevent="openDeleteModal(form)"
                      >
                        <v-icon>delete</v-icon>
                      </v-btn>
                    </template>
                    <span>Delete this submission</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
      <div v-intersect="onIntersect"></div>
    </div>

    <div v-else-if="allSubmissions.length === 0">
      <v-row justify="center" class="mx-4">
        <v-col cols="12" md="12">
          <div class="text-center title">No submission found.</div>
        </v-col>
      </v-row>
    </div>

    <div v-else>
      <v-row justify="center" v-for="i in 6" :key="i" class="mx-4">
        <v-col cols="12" md="12">
          <app-skeleton :type="'image'" :height="'120px'" />
        </v-col>
      </v-row>
    </div>

    <v-dialog v-model="deleteModal" :width="300">
      <v-card>
        <v-card-title class="mx-0 pb-0">Delete submission?</v-card-title>
        <v-card-subtitle class="mx-0 mt-1">Are you sure?</v-card-subtitle>
        <v-card-actions class="text-center">
          <v-spacer></v-spacer>
          <v-btn text class="mr-1 lighten-1" @click="deleteModal = false"
            >Cancel</v-btn
          >
          <v-btn text class="mr-1 lighten-1" @click="deleteSubmission"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import uiHelper from '@/helpers/ui'
import { mapGetters, mapMutations, mapActions } from 'vuex'
// import { EventBus } from '@/eventBus.js'

export default {
  name: 'DashboardFormCard',
  data() {
    return {
      deleteModal: false,
      selectedSubmission: {}
    }
  },

  components: {
    AppSkeleton: () => import('@/components/AppSkeleton')
  },

  computed: {
    ...mapGetters({
      selectedForm: 'form/selectedForm',
      allSubmissions: 'form/allSubmissions',
      privateForms: 'user/privateForms',
      publicForms: 'user/publicForms',
      submissionPageNumber: 'form/submissionPageNumber',
      submissionTotalPagesCount: 'form/submissionTotalPagesCount',
      permissions: 'user/userPermissions',
      dashboardStats: 'user/dashboardStats'
    }),
    deletePermission() {
      if (
        this.permissions.app_permissions.submissions.hasOwnProperty('delete')
      ) {
        return this.permissions.app_permissions.submissions.delete
      }
      return false
    }
  },

  async created() {},

  async mounted() {
    if (!this.privateForms.length) {
      uiHelper.progressBarStatus(true)

      let tagId = null
      if (this.dashboardStats.length) tagId = this.dashboardStats[0].tag_id
      await this.getOpenSubmissions({ tagId })

      uiHelper.progressBarStatus(false)
    }
  },

  methods: {
    ...mapMutations({
      setSelectedSubmissionToken: 'form/setSelectedSubmissionToken',
      setSelectedSubmissionDetails: 'form/setSelectedSubmissionDetails',
      setSelectedSubmission: 'form/setSelectedSubmission',
      setSubmissionPageNumber: 'form/setSubmissionPageNumber',
      setSelectedSubmissionOnHoldStatus:
        'form/setSelectedSubmissionOnHoldStatus',
      setAllSubmissions: 'form/setAllSubmissions'
    }),

    ...mapActions({
      getOpenSubmissions: 'form/getOpenSubmissions',
      getDashboardStats: 'user/getDashboardStats',
      cancelSubmission: 'form/cancelSubmission'
    }),

    async openForm(submission) {
      this.setSelectedSubmissionToken(submission.submission_token)
      this.setSelectedSubmissionDetails(submission)
      this.setSelectedSubmission(submission)
      this.$router.push({
        name: 'Submission',
        params: { id: submission.submission_token }
      })
    },

    onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting === true) {
        if (
          this.submissionTotalPagesCount === 0 ||
          this.submissionTotalPagesCount === 1
        )
          return
        else if (this.submissionPageNumber < this.submissionTotalPagesCount) {
          let submissionPageNumber = this.submissionPageNumber

          this.setSubmissionPageNumber(submissionPageNumber + 1)
          this.getOpenSubmissions()
        }
      }
    },
    openDeleteModal(submission) {
      this.selectedSubmission = submission
      this.setSelectedSubmissionToken(submission.submission_token)
      this.deleteModal = true
    },
    async deleteSubmission() {
      const submission = this.selectedSubmission
      this.setSelectedSubmissionToken(submission.submission_token)
      uiHelper.progressBarStatus(true)

      let response
      try {
        response = await this.cancelSubmission(this.selectedSubmission.form_id)

        let index = this.allSubmissions.findIndex(el => el.id === submission.id)

        let allSubmissions = [...this.allSubmissions]
        allSubmissions.splice(index, 1)
        this.setAllSubmissions(allSubmissions)

        await this.getDashboardStats(this.selectedSubmission.form_id)
        // await this.getOpenSubmissions()
        if (response) {
          uiHelper.showSnackbarMessage('Successfully deleted submission')
        }
        this.deleteModal = false
        this.setSelectedSubmissionToken('')
      } catch (error) {
        uiHelper.showSnackbarMessage(error.response.data.msg, 'error')
      } finally {
        uiHelper.progressBarStatus(false)
      }
    },

    generatePdf(url) {
      if (!url)
        return uiHelper.showSnackbarMessage('something went wrong', 'error')
      window.open(url, '_blank')
    }
  }
}
</script>
